import { render, staticRenderFns } from "./EditClientGroup.vue?vue&type=template&id=b0cbd820&scoped=true"
import script from "./EditClientGroup.vue?vue&type=script&lang=js"
export * from "./EditClientGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0cbd820",
  null
  
)

export default component.exports